
import { ref, defineComponent, computed } from "vue";
import store from "@/stores";
import HLine from "@/components/HLine.vue";
import { useRouter } from "vue-router";
import { routeNames } from "@/router";
import ChangePassword from "@/components/ChangePassword.vue";
import { microWait, toResourceUrl } from "@/lib/shared";
import { consts } from "@/services/Models";

export default defineComponent({
  name: "Header",
  components: {
    HLine,
    ChangePassword,
  },
  props: {
    isHideTitle: { type: Boolean },
  },
  setup() {
    const router = useRouter();
    const login = store.useLoginStore();
    const auth = store.useAuthStore();
    const isOpened = ref(false);
    const isShowModal = ref(false);
    const userInfo = ref<HTMLElement>();
    const mail = computed(() => {
      return auth.state.iam?.email;
    });
    const logout = async () => {
      isOpened.value = false;
      if (await login.signout()) {
        await router.push({ name: routeNames.Login });
      }
    };

    // ユーザ情報の表示
    const toggle = async () => {
      if (!userInfo.value) return;
      isOpened.value = true;
      await microWait();
      userInfo.value.focus();
    };
    const openChangePass = () => {
      isOpened.value = false;
      isShowModal.value = true;
    };
    const toSaveDataList = () => {
      isOpened.value = false;
      router.push({ name: routeNames.SelectEditData });
    };
    // ユーザ情報の非表示
    const hide = async (e: FocusEvent) => {
      if (!userInfo.value) return;
      const isChildClick = userInfo.value.contains(e.relatedTarget as Node);
      if (isChildClick) return;
      isOpened.value = false;
    };
    const isLoggedin = computed(() => auth.state.isLoggedin);
    const helpPdf = computed(() => toResourceUrl(consts.helpPdf));
    return {
      logout,
      toggle,
      isOpened,
      openChangePass,
      toSaveDataList,
      isShowModal,
      mail,
      hide,
      userInfo,
      isLoggedin,
      helpPdf,
    };
  },
});
